import { IconTypesKeys, IJSXOption } from "@evergis/ui";
import { AttributeType } from "@evergis/api";

import { getFieldTypeIcon, getFieldTypeLangKey } from "./fieldTypes";
import { i18n } from "../../../i18n";

import { Attribute } from "../../../interfaces/service";

export interface AttributeOption extends IJSXOption {
  type?: AttributeType;
  value?: string;
  text?: string;
  icon?: IconTypesKeys;
  description: string;
}

const createAttributeDescription = (name: string, type: AttributeType) =>
  `${i18n.t(getFieldTypeLangKey(type), { ns: "common" })}, ${name}`;

export const createAttributeOption = ({ name, alias, type, subType }: Partial<Attribute>): AttributeOption => ({
  value: name,
  text: alias || name,
  type,
  description: createAttributeDescription(name, type),
  icon: getFieldTypeIcon(type, subType) as IconTypesKeys,
});
